import React from 'react';
import { useTimer } from 'react-timer-hook';

const Timer = ({
	expiryTimestamp,
	onExpire,
}: { expiryTimestamp: Date; onExpire: () => void }) => {
	const { minutes, hours } = useTimer({ expiryTimestamp, onExpire });

	return (
		<div>
			<div className="tablet:text-small mobile:text-extraSmall text-gray-gray700 font-interRegular text-center mb-1">
				Berakhir dalam
			</div>
			<div className="flex justify-center items-center">
				<div>
					<div
						className={
							hours === 0 && minutes <= 10
								? 'tablet:w-7.5 tablet:h-7.5 mobile:w-5 mobile:h-5 bg-danger-default flex justify-center items-center rounded'
								: 'tablet:w-7.5 tablet:h-7.5 mobile:w-5 mobile:h-5 p-0.5 bg-primary-green flex justify-center items-center rounded'
						}
					>
						<div className="tablet:text-large mobile:text-small text-white font-interRegular">
							{hours < 10 ? `0${hours}` : hours}
						</div>
					</div>
					<div className="tablet:text-small mobile:text-extraSmall text-gray-gray700 font-interRegular text-center">
						jam
					</div>
				</div>
				<div className="mx-1 tablet:-mt-4 mobile:-mt-3 mobile:text-small text-gray-gray700 font-interRegular t-5">
					:
				</div>
				<div>
					<div
						className={
							hours === 0 && minutes <= 10
								? 'tablet:w-7.5 tablet:h-7.5 mobile:w-5 mobile:h-5 p-0.5 bg-danger-default flex justify-center items-center rounded'
								: 'tablet:w-7.5 tablet:h-7.5 mobile:w-5 mobile:h-5 p-0.5 bg-primary-green flex justify-center items-center rounded'
						}
					>
						<div className="tablet:text-large mobile:text-small text-white font-interRegular">
							{minutes < 10 ? `0${minutes}` : minutes}
						</div>
					</div>
					<div className="tablet:text-small mobile:text-extraSmall text-gray-gray700 font-interRegular text-center">
						menit
					</div>
				</div>
			</div>
		</div>
	);
};

export default Timer;
